/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf17.png';

const GrossMarginsStep6 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="GROSS MARGINS"
    hideAlert={true}
    subTitle="Unit Economics"
    paragraph1={(
      <Fragment>
        Gross margins is an unit economic measurement that informs managers on how much profit they are
        generating on each unit of sale. Some businesses have found success by initiall offering their
        products for free (e.g. freemium model). However, it's really difficult for a business to survive
        if their selling price continues to be below their variable costs (i.e. if they have negative
        gross margins or contribution margins).
      </Fragment>
    )}
    paragraph2={(
      <Fragment>
        Ron Johnson's startup, Enjoy Company, is a great example. At the time Enjoy went public,
        the company was generating both negative gross and contribution margins. Within 9 months,
        Enjoy filed for bankruptcy. <a href="https://www.cnbc.com/2022/06/30/ex-apple-exec-ron-johnsons-enjoy-technology-files-for-bankruptcy.html" rel="noreferrer" target="_blank">Learn More</a>
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default GrossMarginsStep6;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/gross-margins/step6.js